module.exports = __webpack_public_path__ + "static/madeline_chestnut-562f0b1f454f66f079a0ecb1852c8c7c.jpg";